import React from "react"
import styled from "styled-components"
import { up } from "styled-breakpoints"

import { COLORS } from "../../../theme/styles/globals"
import ContentfulBlockMedia from "./ContentfulBlockMedia/ContentfulBlockMedia"
import Carousel from "../../atomic/molecules/Carousel"

export default class ContentfulBlockInstagramCarousel extends React.Component {
  render() {
    const { mode, mediaBlocks } = this.props

    return (
      <React.Fragment>
        {mediaBlocks.map((block, i) => {
          const oddOrEven = i % 2 === 0 ? "even" : "odd"

          let style
          oddOrEven === "even"
            ? (style = { paddingTop: "10%" })
            : (style = { paddingBottom: "10%" })

          return (
            <BlockWrap key={i} mode={mode} style={style}>
              <ContentfulBlockMedia {...block} mode={mode} />
            </BlockWrap>
          )
        })}
        <Carousel id={mediaBlocks[0].contentful_id} mode={mode}>
          {mediaBlocks.map((block, i) => (
            <SlideWrap key={i} mode={mode}>
              <ContentfulBlockMedia {...block} mode={mode} />
            </SlideWrap>
          ))}
        </Carousel>
      </React.Fragment>
    )
  }
}

const BlockWrap = styled.div`
  display: none;
  
  ${up("md")} {
    display: flex;
    border-right: 1px dashed
      ${props =>
        props.mode === "LIGHT" ? COLORS.LIGHT_GREY_2 : COLORS.LIGHT_GREY_4};
    width: 100%;
    height: 100%;
    padding-left: 120px;
    padding-right: 0px;
    justify-content:center;
    align-items:center;
    flex-direction:column;
  }

  &:first-child {
    padding-left: 26px;
  }
`

const SlideWrap = styled.div`
  width: 280px;
  margin-top: 60px;
  padding-left: 14px;
  padding-right: 14px;
`
